import * as React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';

interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  as?: any;
  to?: string;
  icon?: boolean;
  primary?: boolean;
  background?: string;
  size?: 'small' | 'big';
  children?: any;
  className?: string;
  loading?: boolean;
  loadingLabel?: string;
  error?: boolean;
  neutral?: boolean;
}

const StyledButton: any = styled.button<IButtonProps>`
  color: ${(props) => {
    if (props.disabled) {
      return '#474F54';
    }
    if (props.error || props.neutral) {
      return '#ffffff';
    }
    if (props.primary) {
      return props.theme.textPrimary;
    }
    return props.theme.textSecondary;
  }}
  background-color: ${(props) => {
    if (props.disabled) {
      return '#D8D8D8';
    }
    if (props.error) {
      return '#ed5d35';
    }
    if (props.neutral) {
      return '#474F54';
    }
    if (props.primary) {
      return props.theme.primary;
    }
    return props.theme.secondary;
  }}
`;

export const Button = ({
  icon = false,
  size = 'big',
  background = 'white',
  type = 'button',
  primary = false,
  children,
  loading,
  loadingLabel = children,
  className,
  ...props
}: IButtonProps) => (
  <StyledButton
    size={size}
    type={type}
    primary={primary ? 1 : 0}
    className={classNames(
      'leading-default',
      `border-${background} border`,
      'rounded-lg',
      'transition-shadow',
      'focus:outline-none focus:shadow-outline hover:shadow-md',
      {
        loader: loading,
        'pointer-events-none': loading || props.disabled,
        'text-xl': size === 'big',
        'px-8 py-3': !icon && size === 'big',
        'px-5 py-2': !icon && size !== 'big',
        'px-3 py-1 leading-default': icon,
      },
      className
    )}
    {...props}
  >
    {loading ? loadingLabel : children}
  </StyledButton>
);



// WEBPACK FOOTER //
// ./src/components/Button.tsx